var isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};



class LogoList extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.slider.querySelectorAll('li');
    this.sliderBounds = {};
    //if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.update());
    resizeObserver.observe(this.slider);
    this.createObserver();


  }
  update() {
    //console.log('resize');
    // Width is handled in CSS (width: max-content); nothing to measure here.

    
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.sliderBounds = entries[0].intersectionRect;
      this.classList.add('active');
    });

    observer.observe(this);
  }
}

customElements.define('logo-list', LogoList);